var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusCode === 200 || _vm.statusCode === null)?_c('div',{class:{
    'dashboard-layout': true,
    'has-sidebar': _vm.sidebar,
    'is-scrolling-disabled': _vm.disableScrolling,
    'is-small': _vm.size === 'small',
    'is-medium': _vm.size === 'medium',
    'is-large': _vm.size === 'large',
    'is-full': _vm.size === 'full'
  }},[(_vm.sidebar)?_c('div',{staticClass:"sidebar"},[_c('sidebar',[_vm._t("sidebar")],2)],1):_vm._e(),(_vm.isLoading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loader"}):_vm._e(),(!_vm.isLoading)?_c('div',{staticClass:"main"},[(_vm.$slots.breadcrumbs)?_c('div',{class:{
        breadcrumbs: true
      }},[_vm._t("breadcrumbs")],2):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)]):_vm._e()]):_c('div',[_c('error',{attrs:{"status-code":_vm.statusCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }